import hotkeys from 'hotkeys-js';
import { useCallback, useEffect } from 'react';

function useHotkeys(keys, callback) {
  let deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const memoisedCallback = useCallback(callback, deps);
  useEffect(() => {
    hotkeys(keys, memoisedCallback);
    return () => hotkeys.unbind(keys);
  }, [memoisedCallback]);
}

export { useHotkeys };
